import Particle from '../Particle'
import { Accordion, Container, Row, Col, Card, Button } from 'react-bootstrap'
import Web3 from 'web3'
import StakingInfoCard from './StakingInfoCards'
import StakingInputCard from './StakingInputCard'
import Preloader from '../../components/Pre'
import spin from "../../Assets/rpspin.gif";
import nospin from "../../Assets/rpnospin.png";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../redux/data/dataActions";


// import RPTokenFarmB from '../../build/contracts/RUGPULL.json';

const Staking = (props) => {

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [NFTS, setNFTS] = useState([]);
  const [stakedList, setStakedList] = useState([]);
  const [stakedNFTS, setStakedNFTS] = useState([]);
  const [nftStaked, setnftStaked] = useState(true);
  const [nftUnstaked, setnftUnstaked] = useState(true);
  const [claimingRewards, setClaimingRewards] = useState(false);
  const [feedback, setFeedback] = useState("I hope today is your lucky day.");
  const ipfsBaseUrl = "";//"https://boosted.co.za/metedata/";//"https://racex.mypinata.cloud/ipfs/";
  // fetch(ipfsBaseUrl + (nft.uri).substring(7))
  var nfturi = "";
  
  const fetchMetatDataForStakedNFTS = () => {
    if(setnftStaked){
      setnftStaked(false);
      setStakedNFTS([]);
      const myStakedTokens = data.stakedTokens;
      setStakedNFTS([]);
      myStakedTokens.forEach((nft) => {
        if(nft.id != 0){
          nfturi = nft.uri
          nfturi = nfturi.replace('ipfs.infura.io', 'racex.mypinata.cloud')
          nfturi = nfturi.replace('gateway.pinata.cloud', 'racex.mypinata.cloud')
          fetch(nfturi)
          .then((response) => response.json())
          .then((metaData) => {
            setStakedNFTS((initialState) => [
              ...initialState,
              { id: nft.id, metaData: metaData },
            ]);
          })
          .catch((err) => {
            console.log(err);
          });
        }
      });
    }
  }

    /*---------------------------------------------------------------------------------------*/
  const fetchMetatDataForUnstakedNFTS = () => {
    if(setnftUnstaked){
      setnftUnstaked(false);
      setNFTS([]);
      const allTokens = [...data.rpTokens, ...data.shTokens, ...data.csTokens, ...data.jbTokens, ...data.mbTokens];
      // const allTokens = data.allTokens;
      setNFTS([]);
      allTokens.forEach((nft) => {
        if(nft.id != 0){
          nfturi = nft.uri
          nfturi = nfturi.replace('ipfs.infura.io', 'racex.mypinata.cloud')
          nfturi = nfturi.replace('gateway.pinata.cloud', 'racex.mypinata.cloud')
          fetch(nfturi)
            .then((response) => response.json())
            .then((metaData) => {
              setNFTS((initialState) => [
                ...initialState,
                { id: nft.id, metaData: metaData, uri: nft.uri },
              ]);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    }
  };


  useEffect(() => {
    // if(data.loading){
      if (blockchain.account !== "" && blockchain.TDGStakingPool !== null && blockchain.RugpullDetectiveNFT !== null && blockchain.SurelockHolmesNFT !== null && blockchain.CarmellaSantiageNFT !== null) {
        dispatch(fetchData(blockchain.account));
      }
      // fetchMetatDataForUnstakedNFTS();
      // fetchMetatDataForStakedNFTS();
    // }
  }, [blockchain.TDGStakingPool, dispatch, blockchain.CarmellaSantiageNFT, blockchain.RugpullDetectiveNFT, blockchain.SurelockHolmesNFT, blockchain.JanBondNFT, blockchain.MoBoostedNFT, blockchain.account]);

  // useEffect(() => {
  //   fetchMetatDataForStakedNFTS();
  // }, [data.stakedTokens]);

  useEffect(() => {
    // alert("hello");
    // if (blockchain.account !== "" && blockchain.TDGStakingPool !== null && blockchain.RugpullDetectiveNFT !== null && blockchain.SurelockHolmesNFT !== null && blockchain.CarmellaSantiageNFT !== null) {
    //   dispatch(fetchData(blockchain.account));
    // }
    fetchMetatDataForUnstakedNFTS();
    fetchMetatDataForStakedNFTS();
  }, [data.allTokens, data.stakedTokens]);


  // useEffect(() => {
  //   // alert("hello");
  //   fetchMetatDataForUnstakedNFTS();
  //   fetchMetatDataForStakedNFTS();
  // }, [data.allTokens]);

  // useEffect(() => {
  //   // alert("hello");
  //   if(nftUnstaked){
  //     setnftUnstaked(false);
  //     fetchMetatDataForUnstakedNFTS();
  //   }
  //   if(nftStaked){
  //     setnftStaked(false);
  //     fetchMetatDataForStakedNFTS();
  //   }
  // }, [data.allTokens]);

  const claim = async () => {
    blockchain.tdgStakingPool.methods
      .claimDappTokens(blockchain.account)
      .send({
          from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        // setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "TDG Rewards Claimed"
        );
        // setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  }


  function stakeMe(nftId, nftName, nftUri){
    setFeedback("Staking NFT");
    console.log("StakeMe");
    let stakeID = "";
    switch(nftName) {
      case "Rugpull Detective":
        stakeID = nftId + "RD";
        blockchain.rugpullDetectiveNFT.methods
        // .safeTransferFrom(blockchain.account, blockchain.tdgStakingPool._address, nftId)
        .approve(blockchain.tdgStakingPool._address, nftId)
        .send({
            gasLimit: "285000",
              to: blockchain.tdgStakingPool._address,
              from: blockchain.account,
          })
          .once("error", (err) => {
            console.log(err);
            setFeedback("Sorry, something went wrong please try again later.");
            // setClaimingNft(false);
          })
          .then((receipt) => {
            setFeedback(
              "Rugpull Detective NFT approved to Staking Contract"
            );
            // setClaimingNft(false);
            // dispatch(fetchData(blockchain.account));
            blockchain.tdgStakingPool.methods
              .stakeNFT(nftId, blockchain.rugpullDetectiveNFT._address, stakeID, nftUri)
              .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
              })
              .once("error", (err) => {
                console.log(err);
                setFeedback("Sorry, something went wrong please try again later.");
                // setClaimingNft(false);
              })
              .then((receipt) => {
                setFeedback(
                  "Rugpull Detective NFT Staked"
                );
                setnftStaked(true);
                setnftUnstaked(true);
                // setClaimingNft(false);
                dispatch(fetchData(blockchain.account));
              });
          });
      break;
      case "Surelock Holmes":
        stakeID = nftId + "SH";
        blockchain.surelockHolmesNFT.methods
          .approve(blockchain.tdgStakingPool._address, nftId)
          .send({
            gasLimit: "285000",
              to: blockchain.tdgStakingPool._address,
              from: blockchain.account,
          })
          .once("error", (err) => {
            console.log(err);
            setFeedback("Sorry, something went wrong please try again later.");
            // setClaimingNft(false);
          })
          .then((receipt) => {
            setFeedback(
              "Surelock Holmes NFT approved Staking Contract"
            );
            // setClaimingNft(false);
            // dispatch(fetchData(blockchain.account));
            blockchain.tdgStakingPool.methods
              .stakeNFT(nftId, blockchain.surelockHolmesNFT._address, stakeID, nftUri)
              .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
              })
              .once("error", (err) => {
                console.log(err);
                setFeedback("Sorry, something went wrong please try again later.");
                // setClaimingNft(false);
              })
              .then((receipt) => {
                setFeedback(
                  "Surelock Holmes NFT Staked"
                );
                setnftStaked(true);
                setnftUnstaked(true);
                // setClaimingNft(false);
               dispatch(fetchData(blockchain.account));
              });
          });
      break;
      case "Carmella Santiago":
        stakeID = nftId + "CS";
          blockchain.carmellaSantiagoNFT.methods
            .approve(blockchain.tdgStakingPool._address, nftId)
            .send({
              gasLimit: "285000",
              to: blockchain.tdgStakingPool._address,
              from: blockchain.account,
            })
            .once("error", (err) => {
              console.log(err);
              setFeedback("Sorry, something went wrong please try again later.");
              // setClaimingNft(false);
            })
            .then((receipt) => {
              setFeedback(
                "Carmella Santiago NFT approved Staking Contract"
              );
              // setClaimingNft(false);
              // dispatch(fetchData(blockchain.account));
              blockchain.tdgStakingPool.methods
                .stakeNFT(nftId, blockchain.carmellaSantiagoNFT._address, stakeID, nftUri)
                .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
                })
                .once("error", (err) => {
                  console.log(err);
                  setFeedback("Sorry, something went wrong please try again later.");
                  // setClaimingNft(false);
                })
                .then((receipt) => {
                  setFeedback(
                    "Carmella Santiago NFT Staked"
                  );
                  // setClaimingNft(false);
                  setnftStaked(true);
                  setnftUnstaked(true);
                   dispatch(fetchData(blockchain.account));
                });
            });
      break;
      case "Jan Bond":
        stakeID = nftId + "JB";
          blockchain.janBondNFT.methods
            .approve(blockchain.tdgStakingPool._address, nftId)
            .send({
              gasLimit: "285000",
              to: blockchain.tdgStakingPool._address,
              from: blockchain.account,
            })
            .once("error", (err) => {
              console.log(err);
              setFeedback("Sorry, something went wrong please try again later.");
              // setClaimingNft(false);
            })
            .then((receipt) => {
              setFeedback(
                "Jan Bond NFT approved Staking Contract"
              );
              // setClaimingNft(false);
              // dispatch(fetchData(blockchain.account));
              blockchain.tdgStakingPool.methods
                .stakeNFT(nftId, blockchain.janBondNFT._address, stakeID, nftUri)
                .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
                })
                .once("error", (err) => {
                  console.log(err);
                  setFeedback("Sorry, something went wrong please try again later.");
                  // setClaimingNft(false);
                })
                .then((receipt) => {
                  setFeedback(
                    "Jan Bond NFT Staked"
                  );
                  // setClaimingNft(false);
                  setnftStaked(true);
                  setnftUnstaked(true);
                   dispatch(fetchData(blockchain.account));
                });
            });
      break;
      case "Mo Boosted":
        stakeID = nftId + "MB";
          blockchain.moBoostedNFT.methods
            .approve(blockchain.tdgStakingPool._address, nftId)
            .send({
              gasLimit: "285000",
              to: blockchain.tdgStakingPool._address,
              from: blockchain.account,
            })
            .once("error", (err) => {
              console.log(err);
              setFeedback("Sorry, something went wrong please try again later.");
              // setClaimingNft(false);
            })
            .then((receipt) => {
              setFeedback(
                "Mo Boosted NFT approved Staking Contract"
              );
              // setClaimingNft(false);
              // dispatch(fetchData(blockchain.account));
              blockchain.tdgStakingPool.methods
                .stakeNFT(nftId, blockchain.moBoostedNFT._address, stakeID, nftUri)
                .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
                })
                .once("error", (err) => {
                  console.log(err);
                  setFeedback("Sorry, something went wrong please try again later.");
                  // setClaimingNft(false);
                })
                .then((receipt) => {
                  setFeedback(
                    "Mo Boosted NFT Staked"
                  );
                  // setClaimingNft(false);
                  setnftStaked(true);
                  setnftUnstaked(true);
                   dispatch(fetchData(blockchain.account));
                });
            });
      break;
    }
    dispatch(fetchData(blockchain.account));
    // fetchMetatDataForUnstakedNFTS();
    // fetchMetatDataForStakedNFTS();
//    setFeedback("");
  }

  function unstakeMe(nftId, nftName){
    setFeedback("Unstaking NFT");
    console.log("StakeMe");
    let stakeID = "";
    switch(nftName) {
      case "Rugpull Detective":
        stakeID = nftId + "RD";
        blockchain.tdgStakingPool.methods
              .unstakeNFT(nftId, blockchain.rugpullDetectiveNFT._address, stakeID)
              .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
              })
              .once("error", (err) => {
                console.log(err);
                setFeedback("Sorry, something went wrong please try again later.");
                // setClaimingNft(false);
              })
              .then((receipt) => {
                setFeedback(
                  "Rugpull Detective NFT Unstaked"
                );
                // setClaimingNft(false);
                setnftStaked(true);
                setnftUnstaked(true);
             dispatch(fetchData(blockchain.account));
              });
      break;
      case "Surelock Holmes":
        stakeID = nftId + "SH";
        blockchain.tdgStakingPool.methods
              .unstakeNFT(nftId, blockchain.surelockHolmesNFT._address, stakeID)
              .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
              })
              .once("error", (err) => {
                console.log(err);
                setFeedback("Sorry, something went wrong please try again later.");
                // setClaimingNft(false);
              })
              .then((receipt) => {
                setFeedback(
                  "Surelock Holmes NFT Unstaked"
                );
                // setClaimingNft(false);
                setnftStaked(true);
                setnftUnstaked(true);
               dispatch(fetchData(blockchain.account));
              });
      break;
      case "Carmella Santiago":
        stakeID = nftId + "CS";
        blockchain.tdgStakingPool.methods
                .unstakeNFT(nftId, blockchain.carmellaSantiagoNFT._address, stakeID)
                .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
                })
                .once("error", (err) => {
                  console.log(err);
                  setFeedback("Sorry, something went wrong please try again later.");
                  // setClaimingNft(false);
                })
                .then((receipt) => {
                  setFeedback(
                    "Carmella Santiago NFT Unstaked"
                  );
                  // setClaimingNft(false);
                  setnftStaked(true);
                setnftUnstaked(true);
               dispatch(fetchData(blockchain.account));
                });
      break;
      case "Jan Bond":
        stakeID = nftId + "JB";
        blockchain.tdgStakingPool.methods
                .unstakeNFT(nftId, blockchain.janBondNFT._address, stakeID)
                .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
                })
                .once("error", (err) => {
                  console.log(err);
                  setFeedback("Sorry, something went wrong please try again later.");
                  // setClaimingNft(false);
                })
                .then((receipt) => {
                  setFeedback(
                    "Jan Bond NFT Unstaked"
                  );
                  // setClaimingNft(false);
                  setnftStaked(true);
                setnftUnstaked(true);
               dispatch(fetchData(blockchain.account));
                });
      break;
      case "Mo Boosted":
        stakeID = nftId + "MB";
        blockchain.tdgStakingPool.methods
                .unstakeNFT(nftId, blockchain.moBoostedNFT._address, stakeID)
                .send({
                  from: blockchain.account,
                  to: blockchain.tdgStakingPool._address,
                })
                .once("error", (err) => {
                  console.log(err);
                  setFeedback("Sorry, something went wrong please try again later.");
                  // setClaimingNft(false);
                })
                .then((receipt) => {
                  setFeedback(
                    "Mo Boosted NFT Unstaked"
                  );
                  // setClaimingNft(false);
                  setnftStaked(true);
                setnftUnstaked(true);
               dispatch(fetchData(blockchain.account));
                });
      break;
    }
    dispatch(fetchData(blockchain.account));
// fetchMetatDataForUnstakedNFTS();
// fetchMetatDataForStakedNFTS();
// setFeedback("");
  }


  return (
    <Container fluid className="nftgallery-section">

      <Particle />
      <Container>
        <h1 className="nftgallery-heading">
          <strong className="gold">Detective's Guild Staking</strong>
        </h1>
        <Row>
          <h5>
            <strong className="gold">POOL</strong>
          </h5>
        </Row>

        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={4} className="sinfo-card">
            <StakingInfoCard
              title="Weekly Emissions"
              amount={data.weeklyEmmissions}
            />
          </Col>

          <Col md={4} className="sinfo-card">
            <StakingInfoCard title="Daily Emissions" amount={data.dailyEmmissions} />
          </Col>

          <Col md={4} className="sinfo-card">
            <StakingInfoCard title="Total Staked Overall" amount={data.totalStaked} />
          </Col>
        </Row>
        <Row>
          <h5>
            <strong className="gold">MY BALANCES</strong>
          </h5>
        </Row>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={6} className="sinfo-card">
            <StakingInfoCard title="My Total Staked" amount={data.myStakingBalance} />
          </Col>

          <Col md={6} className="sinfo-card">
            <StakingInfoCard
              title="My RugPull Balance" amount={data.rpBalance}
            />
          </Col>
        </Row>
        <Row>
          <h5>
            <strong className="gold">MY REWARDS</strong>
          </h5>
        </Row>
      <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={6} className="sinfo-card">
            <StakingInfoCard title="Rewards To Claim" amount={data.rewardTotal} />
          </Col>


          <Col md={6} className="sinfo-card">
            <Card className="sinfo-card-view">
              <Card.Header>My TDG Balance - {data.tdgBalance}</Card.Header>
              <Card.Body />
              <Button variant="warning" onClick={claim}>
                Claim : {data.claimTokens} <br/>
                TDG Tokens
              </Button>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="sinput-card">
            <Accordion defaultActiveKey="0">
            <Card className="sinput-card-view">
              <Card.Header className="sinfo-card-view" > 
                {/* <Accordion.Toggle as={Card.Header} eventKey="0"> */}
                <strong className="gold">NFT's Available for Staking</strong>
                {/* </Accordion.Toggle> */}
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Row style={{ justifyContent: "center", paddingTop: "5px", paddingBottom: "5px" }}>
                  {data.loading ? (
                    <>
                      <br/>
                      <h5 style={{ textAlign: "center" }}>
                        loading...
                      </h5>
                    </>
                  ) : (
                    NFTS.map((nft, index) => {
                      return(
                        <Col md={3} className="nft-card" key={nft.id+nft.metaData.name}>
                          <Card style={{ width: '7rem' }}  className="sinput-card-view">
                            <Card.Img src={nft.metaData.image.replace('ipfs.infura.io', 'racex.mypinata.cloud')} alt="card-img" style={{paddingBottom: "4px"}} />
                            <Button variant="warning" onClick={() => stakeMe(nft.id, nft.metaData.name, nft.uri)} target="_blank">
                              {"STAKE"}
                            </Button>
                          </Card>
                        </Col>
                      );
                    })
                  )}
                </Row>
              </Accordion.Collapse>
            </Card>
            </Accordion>            
          </Col>
          <Col md={6} className="sinput-card">
            <Accordion defaultActiveKey="0">
            <Card className="sinput-card-view">
              <Card.Header className="sinfo-card-view" >

                {/* <Accordion.Toggle as={Card.Header} eventKey="0"> */}
                <strong className="gold">My Staked NFT's</strong>
                {/* </Accordion.Toggle> */}
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Row style={{ justifyContent: "center", paddingTop: "5px", paddingBottom: "5px" }}>
                  {data.loading ? (
                    <>
                      <br/>
                      <h5 style={{ textAlign: "center" }}>
                        loading...
                      </h5>
                    </>
                  ) : (
                    stakedNFTS.map((nft, index) => {
                      return(
                        <Col md={3} className="nft-card" key={nft.id+nft.metaData.name}>
                          <Card style={{ width: '7rem' }}  className="sinput-card-view">
                            <Card.Img src={nft.metaData.image.replace('ipfs.infura.io', 'racex.mypinata.cloud')} alt="card-img" style={{paddingBottom: "4px"}} />
                            <Button variant="warning" onClick={() => unstakeMe(nft.id, nft.metaData.name)} target="_blank">
                              {"UNSTAKE"}
                            </Button>
                          </Card>
                        </Col>
                      );
                    })
                  )}
                </Row>
              </Accordion.Collapse>
            </Card>
            </Accordion>            
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", paddingTop: "10px", paddingBottom: "10px" }}>
          <strong className="gold">{feedback}</strong>
        </Row>
        <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}/>
        <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}/>
      </Container>
    </Container>
  )
}

export default Staking
